import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-selection"
export default class extends Controller {
  static targets = ["checkBox", "selectAll"];

  checkBoxTargetConnected() {
    this.syncSelectAll();
  }

  checkBoxTargetDisconnected() {
    this.syncSelectAll();
  }

  selectAllTargetConnected() {
    this.syncSelectAll();
  }

  toggleAllCheckBox () {
    const checked = this.hasSelectAllTarget
      ? this.selectAllTarget.checked
      : this.selectableCheckBoxes.some((checkBox) => !checkBox.checked);

    this.selectableCheckBoxes.forEach((checkBox) => (checkBox.checked = checked));
    this.syncSelectAll();
  }

  syncSelectAll() {
    if (!this.hasSelectAllTarget) return;

    const checkedCount = this.selectableCheckBoxes.filter((checkBox) => checkBox.checked).length;
    this.selectAllTarget.checked = checkedCount === this.selectableCheckBoxes.length;
    this.selectAllTarget.indeterminate = checkedCount > 0 && !this.selectAllTarget.checked;
  }

  getSelectedCheckBoxIds() {
    return this.checkBoxTargets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);
  }

  get selectableCheckBoxes() {
    return this.checkBoxTargets.filter((checkBox) => checkBox.dataset.checkboxLocked === undefined);
  }
}
